import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import { Popover, Badge, Icon as AntIcon } from 'antd'
import _ from 'lodash'
import {
  Loading, Div, SmallText, Button, H4, Icon, P,
} from 'konsys-ui'
import history from '../../history'
import {
  Container, RowContainer, Image, EachNoti, ShowAll,
} from './styled'
import {
  getAccessToken, removeAccessToken, removeRefreshToken, getURL, getLocalStorage,
} from '../../utils/local-data-service'
import * as size from '../../constants/screen-size'
import { theme } from '../../styles/_variables'
import Logo from '../../images/login/logo.png'
import { GET_NOTI } from '../../constants/graphql/query'
import { convertModule } from '../../pages/notification-page'

const { color } = theme

export const ContentWrapper = (props) => {
  const [width, setWidth] = useState(window.innerWidth)
  const onMobile = width < size.IPAD

  const screenSizeHandler = () => {
    setWidth(window.innerWidth)
  }

  const logout = () => {
    removeAccessToken()
    removeRefreshToken()
    window.location = `${getURL().WEB_CMS_SERVER}/login`
  }

  useEffect(() => {
    window.addEventListener('resize', screenSizeHandler)
    return () => window.removeEventListener('resize', screenSizeHandler)
  })
  return (
    <Container background={theme.color.whiteSmoke}>
      { !onMobile
        && <Div display='flex' justifyContent='space-between' alignItems='center' margin='0 -60px' padding='0 60px 24px' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
          <RowContainer>
            <Image src={Logo} alt='logo' />
            <H4 bold>บริษัท ผดุงฤทธิ์ ขนส่ง จำกัด</H4>
          </RowContainer>
          <Div display='flex' flexDirection='row' alignItems='center'>
            <SmallText>ยินดีต้อนรับคุณ&nbsp;</SmallText>
            <SmallText bold>{getLocalStorage('fullname')}</SmallText>
            {/* <Query
              query={GET_NOTI}
              fetchPolicy='network-only'
              variables={{
                limit: 5,
              }}
              pollInterval={300000}
            >
              {
                ({
                  loading, data, error, refetch,
                }) => {
                  if (loading && _.isEmpty(data)) return <AntIcon style={{ marginLeft: 8 }} type="loading" spin />
                  if (error) return <P>เกิดข้อผิดพลาด</P>

                  return (
                    <Div display='flex' flexDirection='column' alignItems='flex-end'>
                      <Div display='flex' flexDirection='row' margin="0 0 0 12px">
                        <Popover
                          trigger="click"
                          placement="bottomRight"
                          content={
                            <Div display='flex' flexDirection='column'>
                              {
                                loading && _.isEmpty(data)
                                  ? <Loading/>
                                  : error
                                    ? <P>เกิดข้อผิดพลาด</P>
                                    : !_.isEmpty(data.showAllNoti.notiUnread)
                                      ? _.map(data.showAllNoti.notiUnread, v => (
                                        <Link
                                          to={`/${convertModule(v.mainModule)}/view/${_.split(_.split(_.split(v.message, '(')[1], ' ')[1], ')')[0]}`}
                                        >
                                          <EachNoti read={v.read}>{v.message}</EachNoti>
                                        </Link>))
                                      : <P margin='16px'>ไม่มีรายการแจ้งเตือนที่ไม่ได้อ่าน</P>
                              }
                              <Link to='/notification'><ShowAll>ดูทั้งหมด</ShowAll></Link>
                            </Div>
                          }
                        >
                          {
                            data && data.showAllNoti && <Badge count={data.showAllNoti.countUnread} style={{ fontSize: '10px', padding: '0 4px' }}>
                              <Icon icon="fas fa-bell" fontSize="24px" cursor='pointer' onClick={() => refetch()}/>
                            </Badge>
                          }
                        </Popover>
                      </Div>
                    </Div>
                  )
                }}
            </Query> */}
            <Button text='ออกจากระบบ' icon='far fa-sign-out' small margin='0 0 0 16px' onClick={() => logout()}/>
          </Div>
        </Div>
      }
      { props.children }
    </Container>
  )
}

export const MainContainer = ({ children }) => {
  useEffect(() => {
    if (!getAccessToken()) {
      history.push('/login')
    }
  })

  return (
    <Div>
      { children }
    </Div>
  )
}

export default ContentWrapper
